export const layoutContainerClassName =
  "mx-auto max-w-(--shell-max-width) px-4 desktop:max-w-5xl"
